<template>
    <div v-if="page_init" style="padding-top: 1rem;background:#fff">
        <navTitle title="Isi ulang pemilihan saluran"></navTitle>
        <div style="padding: .3rem">
            <div class="amount">IDR {{amount | MoneyFormat}}</div>
            <div class="title">Silakan masukan informasi dan pilih metode pembayaran Anda.</div>
            <div class="payrow">
                <div class="payinput">
                    <div class="payinput-icon" style="margin-right: .1rem">Metode</div>
                    <select class="payinput-dom" v-model="channel" name="channel">
                        <option value="">Pilih metode pembayaran</option>
                        <option v-for="(item,index) in channels" v-bind:key="index" :value="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="btn" @click="payOKCreate">Kirimkan</div>
    </div>
</template>
<script>
    import {payok_methods_info, payok_create_new} from "@api/user"
    import navTitle from "@components/navTitle.vue"

    export default {
        name: "opsi pembayaran",
        components: {
            navTitle
        },
        data: function () {
            return {
                page_init: false,
                channels: '',
                channel: '',
                amount: ''
            }
        },
        mounted:function() {
            this.amount = this.$route.query.m
            this.getPay()
        },
        methods: {
            getPay() {
                let that = this
                that.$dialog.loading.open('lodaing...')
                payok_methods_info({amount: that.amount}).then(res => {
                    that.channels = res.data
                    if(that.channels.includes('DANAWALLET'))
                        that.channel = 'DANAWALLET'
                    that.page_init = true
                    that.$dialog.loading.close()
                }).catch(() => {
                    that.$dialog.loading.close()
                })
            },
            payOKCreate() {
                if (this.amount > 0) {
                    if (this.amount < 20000) {
                        return this.$dialog.toast({mes: "Minimum 20.000 to top-up"});
                    }
                    if (this.channel === '') {
                        return this.$dialog.toast({mes: "Silakan pilih metode pembayaran"});
                    }
                    let param = {amount: this.amount, channel: this.channel}
                    payok_create_new(param).then(res => {
                        // console.log(res)
                        this.$dialog.loading.close()
                        let payinfo = res.data.res.paymentInfo
                        if (payinfo.type === 'url') {
                            window.location.href = payinfo.content
                        } else {
                            console.log(payinfo)
                            // this.pay_code = payinfo.content
                            // this.showCode = true
                        }
                    }).catch((res) => {
                        console.log(res)
                        this.$dialog.loading.close()
                        this.$dialog.error(res.data.msg)
                    })
                } else {
                    this.$dialog.toast({mes: "Please enter top up amount"});
                }
            }
        }
    };
</script>

<style scoped>
    .amount {
        font-size: 30px;
        font-weight: bold;
        color: #333333;
    }

    .title {
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
        color: #1a242f;
    }

    .payrow {
        width: 100%;
        height: 1rem;
        text-align: center;
        font-size: 0.3rem;

    }

    .payinput {
        width: 100%;
        height: 0.8rem;
        line-height: 0.8rem;
        display: flex;
        margin-top: 0.5rem;
        justify-content: space-between;
    }

    .payinput-icon {
        width: 1.6rem;
        height: 0.8rem;
        line-height: 0.8rem;
        border: 1px solid #eee;
        border-radius: 50%;
    }

    .payinput-dom {
        flex: 1;
        height: 0.8rem;
        line-height: 0.8rem;
        border-bottom: 2px solid #eee;
        transition: all 0.3s;

    }

    .payinput-dom:focus {
        border-bottom: 2px solid #45C3F9;
        transition: all 0.3s;
    }

    .btn {
        width: 90%;
        height: 1rem;
        line-height: 1rem;
        color: #fff;
        background: #45C3F9;
        text-align: center;
        border-radius: 7px;
        font-size: 0.36rem;
        margin: 0.5rem auto 0.8rem auto;
        transition: all 0.3s;

    }

    .btn:active {
        background: rgb(33, 129, 231);
        transition: all 0.3s;

    }
</style>